import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  regUser,
  verifUser,
  userSelector,
  clearState,
  getMarketing,
  loginUser,
  resendOTP,
} from "../features/main/mainSlice";
import Button from "../components/button/Button";
import { Form } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import banner from "../assets/image_1.png";
import user_full_name_icon from "../assets/akun_red.svg";
import user_phone_number_icon from "../assets/phone_red.svg";
// import user_ref_code_icon from "../assets/reff_code_red.svg";
import logoMagnet from "../assets/logo.png";
import email_icon from "../assets/email.svg";
import password_icon from "../assets/password.svg";
import date_icon from "../assets/date.svg";
import { Footer } from '../Template';
import { Link } from "react-router-dom";
import AppModal from "../components/modal/MyModal";
import { useTranslation } from 'react-i18next';
// datetime
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from "moment";

const isHexString = (str) => {
  return /^0x[0-9a-fA-F]+$/.test(str) || /^[0-9a-fA-F]+$/.test(str);
}

const Register = () => {
  const { t } = useTranslation();
  const [showModalDialog, setShowModalDialog] = useState(false);
  const errorRef = useRef(null);
  const {
    isFetching,
    errorMessage,
    isVerifikasi,
    user_id,
    succesCompleteProfile,
    emailLogin,
    passLogin,
    toVerify,
  } = useSelector(userSelector);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const referralCodeParam = query.get('r');
  const hexIdParam = query.get('hx');
  
  const [hexId, setHexId] = useState(undefined);
  useEffect(() => {
    let hexId = hexIdParam;
    if(hexId){
      localStorage.setItem("hexId", hexId);
    }else{
      hexId = localStorage.getItem("hexId");
    }
    setHexId(hexId);
  },[hexIdParam])

  const dispatch = useDispatch();

  const initData = {

    phone_number: "",
    kode_verifikasi: "",
    nama_depan: "",

    tgl: "",
    bln: "",
    thn: "",
    cabang: "",
    marketing: "",
    tanggal_lahir: "",
    myCaptcha: "",
    ref_code: "",
    email: "",
    password: "",
  };
  const errorValidate = {

    phone_number: "",
    kode_verifikasi: "",

    tgl: "",
    bln: "",
    thn: "",
    cabang: "",
    marketing: "",
    myCaptcha: "",
    ref_code: "",
  };
  const [selected, setSelected] = useState(initData);
  const [errMsg, setErrMsg] = useState(errorValidate);
  const [errorValidationPasswordCheck, setErrorValidationPasswordCheck] = useState(
    {
      isMatchOneLetter: false,
      isMatchNumber: false,
      isMatchMinDigit: false
    }
  )
  // const [isDisabledRefCode, setDisableRefCode] = useState(false);

  useEffect(() => {
    if (succesCompleteProfile) {
      const queryString = {
        email: selected.email,
        password: selected.password,
      };

      dispatch(loginUser(queryString));
    }

  }, [succesCompleteProfile, dispatch, selected, toVerify, emailLogin, passLogin, user_id]);

  const formik = useFormik({
    initialValues: {
      nama_depan: "",
      phone_number: "",
      tanggal_lahir: "",
      email: "",
      password: "",
      konfirmasi_password: "",
      reff_code: ""
    },
    validationSchema: Yup.object({
      nama_depan: Yup.string()
        .required(t('register.error_message_name')),
      phone_number: Yup.number()
        .required(t('register.error_message_handphone')),
      tanggal_lahir: Yup.date()
        .required(t('register.error_message_birthday'))
        .max(moment().subtract(21, "years"), t('register.error_message_birthday_limit_age')),
      email: Yup.string()
        .required(t('register.error_message_email'))
        .email(t('register.error_message_email_valid')),
      password: Yup.string()
        .required(t('register.error_message_password')),
      konfirmasi_password: Yup.string()
        .required(t('register.error_message_confirm_password'))
        .oneOf([Yup.ref("password")], t('register.error_message_confirm_password_same')),
    }),
    onSubmit: (values) => {
      if (values.reff_code) {
        values.reff_code = values.reff_code.replace(/-/g, "");
        values.reff_code = values.reff_code.substring(0, 3) + "-" + values.reff_code.substring(3);
      }

      values.cdd = 1;

      // console.log(values);
      setSelected({
        ...selected,
        password: values.password,
        email: values.email,
      });
      dispatch(regUser({
        ...values,
        tanggal_lahir: moment(values.tanggal_lahir).format('YYYY-MM-DD'),
        ...(hexId && isHexString(hexId) ? { mgm_id: parseInt(hexId, 16) } : {})
      }));
    },
    // handleChange: (values) => {
    //   console.log(values)
    // }
  });

  useEffect(() => {
    let refCode = referralCodeParam;    
    if(hexId === '322f5'){
      refCode = '801-250001';
    }
    if(hexId === '322f8'){
      refCode = '802-250001';
    }

    if (refCode !== null && refCode !== "") {
      // setDisableRefCode(true);
      if (refCode.length === 9) {
        refCode = refCode.substring(0, 3) + "-" + refCode.substring(3);
      }
      formik.setFieldValue("reff_code", refCode);
      localStorage.setItem("refCode", refCode);
    } else {
      const locStorageRefCode = localStorage.getItem("refCode");
      refCode = locStorageRefCode;
      if (locStorageRefCode && locStorageRefCode !== null && locStorageRefCode !== "") {
        // setDisableRefCode(true);
        if (locStorageRefCode.length === 9) {
          refCode = locStorageRefCode.substring(0, 3) + "-" + locStorageRefCode.substring(3);
        }
        formik.setFieldValue("reff_code", refCode);
      }
    }
  }, [referralCodeParam, hexId]);

  // const getData = (value) => {
  //   // console.log("value=" + value);
  //   if (value === null) return "";
  //   if (value.length < 3) { return value; }
  //   return value.substring(0, 3) + "-" + value.substring(4);
  // }

  const handleChange = (event) => {
    const { name, value } = event.target;
    let val = value;
    setSelected({
      ...selected,
      [name]: val,
    });

    if (name === "cabang") {
      const queryString = {
        kode_cabang: val,
      };
      dispatch(getMarketing(queryString));
    }
    dispatch(clearState());
  };

  // const checkStateErrorValidationPasswordCheck = () => {
  //   if (errorValidationPasswordCheck.isMatchNumber === true)
  //     return true

  //   if (errorValidationPasswordCheck.isMatchMinDigit === true)
  //     return true

  //   if (errorValidationPasswordCheck.isMatchOneLetter === false)
  //     return true

  //   return false
  // }

  const handleSubmit = () => {
    let error = "";
    if (selected.kode_verifikasi === null || selected.kode_verifikasi === "") {
      error = { ...error, kode_verifikasi: "Required!" };
    }

    // if(checkStateErrorValidationPasswordCheck()){
    //   error = { ...error, password: "Password belum sesuai" };
    // }

    // console.log(error,errorValidationPasswordCheck)

    setErrMsg(error);
    let queryString = {};
    if (toVerify) {
      queryString = {
        user_id: user_id,
        kode_verifikasi: selected.kode_verifikasi,
      };
    } else {
      queryString = {
        ...selected,
        user_id: user_id,
      };
    }
    if (!error) dispatch(verifUser(queryString));
  };

  function handleChangeCaptcha(value) {
    setSelected({
      ...selected,
      myCaptcha: value,
    });
    //console.log("Captcha value:", value);
  }

  function handleExpired() {
    const recaptchaValue = recaptchaRef.current.getValue();
    setSelected({
      ...selected,
      myCaptcha: recaptchaValue,
    });
    // console.log("recaptchaValue:", recaptchaValue);
  }

  function handleResendOTP() {
    setSelected({
      email: selected.email,
    });
    const queryString = {
      email: selected.email,
    };
    //console.log(queryString);
    dispatch(resendOTP(queryString));

    setShowModalDialog(true);
  }

  const recaptchaRef = React.createRef();

  const hideAlert = () => {
    dispatch(clearState());
  };
  document.getElementById("root").classList = "hold-transition";

  const updateErrorValidationPassword = (str) => {
    const regexMatchOneLetter = /^-?\d*\.?\d*$/;
    const regexMatchNumber = /\d/;

    setErrorValidationPasswordCheck({
      isMatchOneLetter: regexMatchOneLetter.test(str) ? false : true,
      isMatchNumber: regexMatchNumber.test(str) ? true : false,
      isMatchMinDigit: str.length >= 8 ? true : false
    })
  }

  useEffect(() => {
    if(errorMessage){
      errorRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  },[errorMessage])

  const frmUser = (
    <Form id="myForm" onSubmit={(e) => {
      e.preventDefault();
      handleSubmit();
    }}>
      <Form.Group controlId="kode_verifikasi">
        <Form.Label>
          <div className="w-full mb-0 mt-0">
            <div className="text-merah-button  text-lg text-center font-normal ">
              {t('register.text_verification')}
            </div>
          </div>

          <div className="w-full mb-2 mt-2">
            <div className="text-black  text-xs text-center font-normal">
              {t('register.text_enter_code_activation')}{" "}{selected.email}
            </div>
          </div>
        </Form.Label>
        {errMsg.kode_verifikasi ? (
          <span className="float-right text-error badge badge-danger">
            {errMsg.kode_verifikasi}
          </span>
        ) : (
          ""
        )}
        <Form.Control
          size="sm"
          autoComplete="off"
          name="kode_verifikasi"
          type="text"
          value={selected.kode_verifikasi}
          onChange={handleChange}
          placeholder="123456"
        />
      </Form.Group>

      <div className="social-auth-links text-center mt-2 mb-3">
        <div className="grid grid-cols-1 gap-0 place-items-center">
          <div className="w-full mb-2">
            <div className="text-black text-sm ">
              {t('register.text_dont_have_code_activation')}
              <a
                href="javascript:void(0)"
                onClick={handleResendOTP}
                className="text-center italic text-hijau-forex"
              >
                <br /> {t('register.text_send_again_code')}
              </a>
            </div>
          </div>
          <div className="w-2/4 mt-2">
            <Button
              block
              onClick={() => handleSubmit()}
              isLoading={isFetching}
              theme=""
              type="submit"
              style={{ backgroundColor: "#C1242B", color: "#fff" }}
            >
              {t('register.btn_submit')}
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Toggle the visibility of the password
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <div >
      <div className="w-full grid lg:grid-cols-2 gap-4 bg-white">
        <div className="overflow-hidden mobile-view mb-5 mr-1">
          <img src={banner} className="w-[100%] h-[100%]" alt="" />
        </div>

        <div className="grid grid-cols-1 gap-0 place-items-center">
          <div className="login-box ">
            <div className="card border-white">
              <div ref={errorRef} className="card-header text-center h1 text-red-500 text-lg bg-white border-white grid grid-cols-1 place-items-center lg:mt-4">
                <div className="grid grid-cols-1 place-items-center">
                  <Link to="/login"><img src={logoMagnet} width="60%" alt="" /></Link>
                </div>
                <div>
                  <b>
                    <span className="text-merah-button font-bold text-lg">
                      {t('register.text_register')}
                    </span>
                  </b>
                </div>
              </div>

              <div className="card-body" style={{ paddingTop: "0px", paddingRight: '35px' }}>
                {errorMessage && errorMessage !== '5' && errorMessage !== '3' ? (
                  <div className="alert alert-sm" style={{ backgroundColor: "#C2262C" }}>
                    <button
                      onClick={hideAlert}
                      type="button"
                      className="close text-white"
                      data-dismiss="alert"
                      aria-hidden="true"
                      style={{ opacity: 1 }}
                    >
                      ×
                    </button>
                    <span className="text-bold text-white">
                      Error: {errorMessage}
                    </span>
                  </div>
                ) : (
                  <p className="login-box-msg"></p>
                )}

                {(!isVerifikasi && !succesCompleteProfile) &&
                  <form onSubmit={formik.handleSubmit}>

                    {formik.touched.nama_depan && formik.errors.nama_depan ? (
                      <span className="float-right text-error badge badge-danger">
                        {formik.errors.nama_depan}
                      </span>
                    ) : null}
                    <div
                      className="input-group mb-3"
                      style={{
                        border: "1px solid #B7B7B7",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="input-group-append">
                        <div className="input-group-text bg-white border-white">
                          <img src={user_full_name_icon} width="22px" alt="" />
                        </div>
                      </div>
                      <input
                        autoFocus
                        autoComplete="off"
                        type="text"
                        className="form-control"
                        placeholder={t('register.field_name')}
                        style={{ backgroundColor: "#fff", border: "0" }}
                        {...formik.getFieldProps("nama_depan")}
                      />
                    </div>

                    {formik.touched.phone_number && formik.errors.phone_number ? (
                      <span className="float-right text-error badge badge-danger">
                        {formik.errors.phone_number}
                      </span>
                    ) : null}
                    <div
                      className="input-group mb-3"
                      style={{
                        border: "1px solid #B7B7B7",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="input-group-append">
                        <div className="input-group-text bg-white border-white">
                          <img src={user_phone_number_icon} width="22px" alt="" />
                        </div>
                      </div>
                      <input

                        type="number"
                        className="form-control"
                        placeholder={t('register.field_no_handphone')}
                        style={{ backgroundColor: "#fff", border: "0" }}
                        {...formik.getFieldProps("phone_number")}
                      />
                    </div>

                    {formik.touched.tanggal_lahir && formik.errors.tanggal_lahir ? (
                      <span className="float-right text-error badge badge-danger">
                        {formik.errors.tanggal_lahir}
                      </span>
                    ) : null}
                    <div
                      className="input-group mb-3"
                      style={{
                        border: "1px solid #B7B7B7",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="input-group-append">
                        <div className="input-group-text bg-white border-white">
                          <img src={date_icon} width="22px" alt="" style={{ padding: '1px' }} />
                        </div>
                      </div>
                      <Datetime
                        className="flex-auto"
                        closeOnSelect={true}
                        timeFormat={false}
                        initialViewDate={moment().subtract(21, "years")}
                        onChange={(value) => {
                          let dateValue = '';
                          if (value instanceof moment) {
                            dateValue = moment(value);
                          }
                          formik.setFieldValue("tanggal_lahir", dateValue)
                        }}
                        inputProps={{
                          readOnly: true,
                          placeholder: 'Tanggal Lahir',
                          name: 'tanggal_lahir',
                          className: "form-control border-0",
                          ref: el => {
                            if (el) {
                              el.style.setProperty('background-color', 'white', 'important');
                            }
                          },
                          onBlur: () => formik.setFieldTouched("tanggal_lahir", true)
                        }}
                        locale="id"
                      />
                    </div>

                    {formik.touched.email && formik.errors.email ? (
                      <span className="float-right text-error badge badge-danger">
                        {formik.errors.email}
                      </span>
                    ) : null}
                    <div
                      className="input-group mb-3"
                      style={{
                        border: "1px solid #B7B7B7",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="input-group-append">
                        <div className="input-group-text bg-white border-white">
                          <img src={email_icon} width="22px" alt="" />
                        </div>
                      </div>
                      <input

                        type="text"
                        className="form-control"
                        placeholder={t('register.field_email')}
                        style={{ backgroundColor: "#fff", border: "0" }}
                        {...formik.getFieldProps("email")}
                      />
                    </div>
                    {formik.values.password === "" &&
                      formik.errors.password ? (
                      <span className="float-right text-error badge badge-danger">
                        {formik.errors.password}
                      </span>
                    ) : null}
                    <div
                      className={"input-group " + (formik.touched.password ? "mb-1" : "mb-3")}
                      style={{
                        border: "1px solid #B7B7B7",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="input-group-prepend">
                        <div className="input-group-text bg-white border-white">
                          <img src={password_icon} width="22px" alt="" />
                        </div>
                      </div>
                      <input
                        autoComplete="off"
                        type={showPassword ? "text":"password"}
                        className="form-control"
                        placeholder={t('register.field_password')}
                        name="password"
                        style={{ backgroundColor: "#fff", border: "0" }}
                        onChange={(event) => {
                          const { name, value } = event.target
                          updateErrorValidationPassword(value)
                          formik.setFieldValue(name, value)
                        }}
                      // onChange={formik.handleChange}
                      />
                      <div className="input-group-append">
                        <div className="input-group-text bg-white border-white">
                          <span onClick={togglePasswordVisibility}>
                            {showPassword ? <i className="fa fa-eye"/> : <i className="fa fa-eye-slash"/>}
                          </span>
                        </div>
                      </div>
                    </div>
                    {
                      formik.values.password ? (
                        <div className="flex flex-col input-group mb-1">
                          <p className="text-muted mb-2">{t('register.text_title_rules_password')}</p>
                          <ul>

                            <li className={`text-xs mb-1 ml-3 ${errorValidationPasswordCheck.isMatchOneLetter ? 'text-success' : 'text-danger'}`}>
                              <i className={`fa ${errorValidationPasswordCheck.isMatchOneLetter ? 'fa-check' : 'fa-times'}`}></i> {t('register.rules_password.text_one_more')} <b>{t('register.rules_password.text_one_letter')}</b>
                            </li>
                            <li className={`text-xs mb-1 ml-3 ${errorValidationPasswordCheck.isMatchNumber ? 'text-success' : 'text-danger'}`}>
                              <i className={`fa ${errorValidationPasswordCheck.isMatchNumber ? 'fa-check' : 'fa-times'}`}></i> {t('register.rules_password.text_one_more')} <b>{t('register.rules_password.text_one_number')}</b>
                            </li>
                            <li className={`text-xs mb-1 ml-3 ${errorValidationPasswordCheck.isMatchMinDigit ? 'text-success' : 'text-danger'}`}>
                              <i className={`fa ${errorValidationPasswordCheck.isMatchMinDigit ? 'fa-check' : 'fa-times'}`}></i> {t('register.rules_password.text_one_minimum')}
                              <b> {t('register.rules_password.text_one_count')}</b> {t('register.rules_password.text_one_leter_number')}
                            </li>
                          </ul>
                        </div>
                      ) : ''
                    }


                    {formik.touched.konfirmasi_password &&
                      formik.errors.konfirmasi_password ? (
                      <span className="float-right text-error badge badge-danger">
                        {formik.errors.konfirmasi_password}
                      </span>
                    ) : null}
                    <div
                      className="input-group mb-3"
                      style={{
                        border: "1px solid #B7B7B7",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="input-group-prepend">
                        <div className="input-group-text bg-white border-white">
                          <img src={password_icon} width="22px" alt="" />
                        </div>
                      </div>
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        placeholder={t('register.field_confirm_password')}
                        style={{ backgroundColor: "#fff", border: "0" }}
                        {...formik.getFieldProps("konfirmasi_password")}
                      />
                      <div className="input-group-append">
                        <div className="input-group-text bg-white border-white">
                          <span onClick={toggleConfirmPasswordVisibility}>
                            {showConfirmPassword ? <i className="fa fa-eye"/> : <i className="fa fa-eye-slash"/>}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* <div
                      className="input-group mb-3"
                      style={{
                        border: "1px solid #B7B7B7",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="input-group-append">
                        <div className="input-group-text bg-white border-white">
                          <img src={user_ref_code_icon} width="22px" alt="" />
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t('register.field_referral_code')}
                        style={{ backgroundColor: "#fff", border: "0" }}
                        {...formik.getFieldProps("reff_code")}
                        disabled={isDisabledRefCode}
                        value={getData(formik.values.reff_code)}
                      />
                    </div> */}

                    <ReCAPTCHA
                      hl="id"
                      ref={recaptchaRef}
                      sitekey="6LfuzEEkAAAAAIg19QrJ7P8Knk5RvDvTV7OJpuEN"
                      onChange={handleChangeCaptcha}
                      onExpired={handleExpired}
                    />
                    <div className="social-auth-links text-center mt-2 mb-3">
                      <div className="grid grid-cols-1 gap-0 place-items-center">
                        <div className="w-2/4">
                          <Button
                            disabled={selected.myCaptcha ? (
                              !errorValidationPasswordCheck.isMatchOneLetter
                                || !errorValidationPasswordCheck.isMatchNumber
                                || !errorValidationPasswordCheck.isMatchMinDigit ? true : false) : true
                            }
                            block
                            type="submit"
                            isLoading={isFetching}
                            theme=""
                            style={{
                              backgroundColor: "#C1242B",
                              color: "#fff",
                              marginRight: "2%",
                            }}
                          >
                            {t('register.btn_submit')}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </form>}


                <div className="text-left">
                  {isVerifikasi ? frmUser : ""}
                  {succesCompleteProfile ? (
                    <h4>
                      <p className="login-box-msg">
                        {t('register.text_succes_register')},{" "}
                        <a href="login" className="text-center">
                          {t('register.text_please_login')}
                        </a>
                      </p>
                    </h4>
                  ) : (
                    ""
                  )}
                  {!succesCompleteProfile ? (
                    <div className="text-black text-center">
                      {t('register.text_have_account')}{" "}
                      <a
                        href="login"
                        className="text-center font-bold text-hijau-forex"
                      >
                        {t('register.btn_login')}
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="h-auto overflow-hidden mobile-hide">
          <img src={banner} className="w-[100%] h-[100%]" alt="" />
        </div>
      </div>
      <AppModal
        show={showModalDialog}
        size="sm"
        form="Periksa lagi email kamu, Magnet baru mengirimkan ulang kode aktivasi"
        handleClose={() => setShowModalDialog(false)}
        backdrop="static"
        keyboard={false}
        noBtnAction={true}
        myCloseButton={true}
        title="Info"
        titleButton="Delete"
        themeButton="danger"
      ></AppModal>
      <Footer></Footer>
    </div>
  );
};

export default Register;
